// extracted by mini-css-extract-plugin
export var sliderPagination = "slider-pagination-module--slider-pagination--lJT0i";
export var sliderPagination__button = "slider-pagination-module--slider-pagination__button--oXzE4";
export var active = "slider-pagination-module--active--O+X4k";